import React from 'react';
import {Box, Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {saveLogin} from 'common/reducer/auth';
import GoogleButton from 'view/login/GoogleButton';
import NaverButton from 'view/login/NaverButton';
import KakaoButton from 'view/login/KakaoButton';
import HeaderView from 'view/common/Header';
import {
  wholeLoginPage,
  loginTitle1,
  loginTitle2,
  loginKakaoBox,
  loginNaverBox,
  loginGoogleBox,
  loginEnterpriseBox,
} from 'view/login/Styles';
import APIUtils from 'common/utils/APIUtils';
import FooterView from 'view/common/Footer';
import {useCookies} from 'react-cookie';
import {loginBox} from 'view/login/Styles';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authReducer = useSelector(state => state.authReducer);
  const [cookies, setCookie] = useCookies(['lastTime']);

  function onGoogleSuccess(token) {
    callLoginAPI('google', token);
  }
  function onNaverSuccess(token) {
    callLoginAPI('naver', token);
  }
  function onKakaoSuccess(token) {
    callLoginAPI('kakao', token);
  }
  function callLoginAPI(access_path, access_token) {
    const loginResult = async (path, token) => {
      try {
        const response = await APIUtils.AccountLogin(path, token);
        if (response.data.ret_code == 1000) {
          dispatch(
            saveLogin({
              user_type: response.data.user_type,
              student_id: response.data.student_id,
              student_name: response.data.student_name,
              student_email: response.data.student_email,
              path: path,
            }),
          );
          setCookie('lastTime', new Date());
          for (var i = 0; i < localStorage.length; i++) {
            var foundKey = localStorage.key(i);
            if (
              foundKey.includes('taskTitle') ||
              foundKey.includes('taskBody') ||
              foundKey.includes('task_id') ||
              foundKey.includes('practiceBody') ||
              foundKey.includes('practiceTitle') ||
              foundKey.includes('practiceJanre')
            ) {
              localStorage.removeItem(foundKey);
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
    loginResult(access_path, access_token).then(r => {
      navigate('/mypage');
    });
  }
  return (
    <Box style={wholeLoginPage}>
      <HeaderView />
      <Box style={{minHeight: '55vh'}}>
        <br></br>
        키위런은 이름과 전화번호 등 개인정보를 수집하지 않습니다. <br></br>
        구글 등의 계정을 이용해서 간편하게 가입하고, 로그인할 수 있습니다.{' '}
        <br></br>
        또는, 선생님이 알려주신 ID/PW로 로그인할 수 있습니다.
        <Box style={{display: 'flex', justifyContent: 'end'}}>
          <Button
            style={{
              color: 'blue',
              textDecoration: 'underline',
              marginTop: '1rem',
              fontWeight: 'bold',
            }}
            onClick={() => {
              window.open('https://keewi-t.korean.ai');
            }}
          >
            선생님은 키위티로 이동
          </Button>
        </Box>
        <Box style={loginEnterpriseBox}>
          <Button
            style={loginBox.coloredBox('#279eff')}
            onClick={() => {
              navigate('/login/enterprise');
            }}
          >
            ID로 로그인하기
          </Button>
        </Box>
        <Box style={loginGoogleBox}>
          <GoogleButton onSuccess={onGoogleSuccess} />
        </Box>
        <Box style={loginKakaoBox}>
          <KakaoButton onSuccess={onKakaoSuccess} />
        </Box>
        <Box style={loginNaverBox}>
          <NaverButton onSuccess={onNaverSuccess} />
        </Box>
      </Box>
      <FooterView />
    </Box>
  );
};
export default LoginPage;
